export { default as StoreSelector } from './store-selector';
